import Api from 'api'

const config = {
  baseURL: '/api/app/v1/tickets',
}
const api = new Api(config)

api.fetchTickets = ({ ...rest }) => api.get(``, { ...rest })

api.fetchTicketById = ({ id }) => api.get(`/${id}`)

api.create = ({ ...rest }) => api.post(``, { ...rest })

api.send = ({ id, ...rest }) => api.post(`/${id}`, { ...rest })

api.close = ({ id }) => api.post(`/${id}/close`)

api.reopen = ({ id }) => api.post(`/${id}/reopen`)

api.upload = ({ ...rest }) =>
  api.post(`/upload`, {
    ...rest,
  })

export default api
